import { render } from 'preact';
import 'uplot/dist/uPlot.min.css';
import './styles/global.css';
import { App } from './app.js';
import { registerServiceWorker } from './lib/sw-register.js';

const root = document.getElementById('app');
if (root) {
  render(<App />, root);
}

registerServiceWorker();
